import { colors } from '@akin-home/theme';
import { useEffect } from 'react';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import styled from 'styled-components/native';

export * from './ProgressBarCountdown';

interface Props {
  target: number;
  current: number;

  style?: any;
}

export const ProgressBar = (props: Props) => {
  if (props.target === 1 || props.target > 5) {
    return <Bar {...props} />;
  }

  return (
    <MultiBarContainer>
      {[...Array(props.target)].map((_, idx) => (
        <MiniBar key={idx} target={1} current={props.current > idx ? 1 : 0} />
      ))}
    </MultiBarContainer>
  );
};

const Bar = ({ current, target, style }: Props) => {
  const width = useSharedValue((current / target) * 100);

  const styles = useAnimatedStyle(() => {
    return {
      width: withTiming(width.value + '%', {
        duration: 400,
        easing: Easing.inOut(Easing.ease),
      }),
    };
  });

  useEffect(() => {
    width.value = (current / target) * 100;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, current]);

  return (
    <UnderBar style={style}>
      <GreenBar style={styles} />
    </UnderBar>
  );
};

const MiniBar = styled(Bar)`
  flex: 1;
`;

const UnderBar = styled.View`
  background-color: ${colors.neutral[10]};
  height: 12px;
  border-radius: 8px;
`;

const GreenBar = styled(Animated.View)`
  background-color: ${colors.success[60]};
  height: 12px;
  border-radius: 8px;
`;

const MultiBarContainer = styled.View`
  flex-direction: row;
  gap: 5px;
`;
